import { langMap, loadLangs } from "@ubif/components";
import React from "react";
import ReactDOMClient from "react-dom/client";
import { registerApplication, start } from "single-spa";
import singleSpaReact from "single-spa-react";

import Root from "./root.component";

/* eslint-disable */
if (process.env.NODE_ENV !== "production") {
  loadLangs(langMap({ ns: "root-config", resources: (lang, ns) => require(`./locales/${lang}/${ns}.json`) }));
}
/* eslint-enable */

const mainLayoutApplication = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary() {
    // Customize the root error boundary for your microfrontend here.
    return null;
  }
});

registerApplication({
  name: "@ubif/main-layout",
  app: mainLayoutApplication,
  activeWhen: () => true
});

start();
